<app-table 	[displayedColumns]="displayedColumns" 
			[columns]="columns" 
			[pageSize]="25" 
			url="/teachers/lessons"
			[title]="'teachers-lessons'|translate"
			sortColumn="created_at"
			sortDirection="desc"
			formLink='/teacher/lessons/'
			editParam='uuid'>
</app-table>